(function () {
  var US_LIKE_THRESHOLD = 40;
  var INTL_THRESHOLD = 90;
  var INTL_CURRENCIES = ['USD', 'EUR', 'GBP'];
  var US_LIKE = ['AU', 'CA', 'MX', 'NZ', 'US'];

  function getThreshold(country, currency) {
    if (US_LIKE.indexOf(country) > -1) return US_LIKE_THRESHOLD;
    if (INTL_CURRENCIES.indexOf(currency) > -1) return INTL_THRESHOLD;
    return null;
  }

  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  function update() {
    var els = document.querySelectorAll('[data-rb-ship-value]');
    if (!els.length) return;

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var country = (window.Shopify && Shopify.country) || '';
        var threshold = getThreshold(country, cart.currency);
        var isFree = threshold !== null && cart.item_count > 0 && cart.total_price / 100 >= threshold;

        els.forEach(function (el) {
          setText(el, isFree ? 'Free' : 'Calculated at checkout');
        });
      })
      .catch(function (e) { console.error('[rb-ship]', e); });
  }

  var t;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(update, 250);
  }

  function init() {
    update();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();